export default "__VITE_ASSET__CS4oCTT8__"